import { Form, Input, Row, Col, Edit, notification, Button, Icons } from '@pankod/refine-antd';
import { useEffect } from 'react';
import { getExpenseCategory, updateExpenseCategory } from 'services/expense-category';

export const ExpenseCategoryEdit: React.FC = () => {
  const [form] = Form.useForm();
  const pathName = window.location.pathname.split('/');
  const editId = pathName[pathName.length - 1];

  useEffect(() => {
    (async () => {
      try {
        const data = await getExpenseCategory(editId);
        form.setFieldsValue({
          name: data.name,
          description: data.description,
        });
      } catch (err) {
        if (err instanceof Error) {
          notification.error({
            message: 'Failed',
            description: err.message,
          });
        }
      }
    })();
  }, [editId, form]);

  const onFinish = async (values: any) => {
    try {
      const data = {
        name: values.name,
        description: values.description,
      };
      await updateExpenseCategory(editId, data);
    } catch (err) {
      notification.error({
        message: 'Failed',
        description: 'Failed to update company info',
      });
    }
  };

  return (
    <Edit title="Edit Expense Category" headerProps={{ extra: null }} headerButtons={<></>}>
      <Form layout="vertical" form={form} onFinish={onFinish}>
        <Row justify="space-around" align="middle">
          <Col xs={24} lg={12}>
            <Form.Item
              label="Name"
              name="name"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item label="Description" name="description">
              <Input.TextArea rows={8} />
            </Form.Item>
            <Form.Item wrapperCol={{ span: 4, offset: 20 }} style={{ marginTop: '2rem' }}>
              <Button type="primary" htmlType="submit" icon={<Icons.SaveOutlined />}>
                Save
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Edit>
  );
};
